<template>
	<div class="zzgk_dialog">
		<el-dialog 
			:modal-append-to-body='true'
			width="500px"
			center
			:append-to-body='true'
			@close="closeUpload"
			:visible.sync="moreAddwin">
			<div slot="title" class="addtitle">
				<div>
					<i class="icon adddzz"></i>
					上传文件
					<div class="addline"></div>
				</div>
			</div>
			<div class="formData1">
				<el-form ref="formData" :model="formData" class="formWrap" label-width="120" label-position="right">
					<el-form-item class="form_item" label="介绍信:">
						<el-upload
							name="file"
							:data="{token:$store.state.user.userinfo.token}"
							:action="$uploadFile"
							:on-remove="removeFile"
							:on-success="success"
							:file-list="fileList"
							:before-upload="limitFile">
							<el-button type="primary">上传文件</el-button>
						</el-upload>
					</el-form-item>
					<el-form-item class="form_item" label="回执:">
						<el-upload
							:data="{token:$store.state.user.userinfo.token}"
							name="file"
							:action="$uploadFile"
							:on-remove="removeFile1"
							:on-success="success1"
							:file-list="fileList1"
							:before-upload="limitFile">
							<el-button type="primary">上传文件</el-button>
						</el-upload>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="pushData()">保 存</el-button>
				<el-button @click="closeUpload">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { Message } from 'element-ui'
	import { dyjy } from '@/axios'
	export default{
		data(){
			return{
				formData:{
					uid:"",
					introduce:"",
					receipt:"",
				},
				fileList:[],
				fileList1:[]
			}
		},
		props:{
			moreAddwin:{
				type:Boolean,
				default:false
			},
			uid:{
				type:String,
				default:""
			}
		},
		methods:{
			// 关闭弹窗
			closeUpload(){
				var that = this;
				that.formData = {
					uid:"",
					introduce:"",
					receipt:"",
				};
				that.fileList = [];
				that.fileList1 = [];
				that.$emit("closeUpload")
			},
			// 图片上传限制
			limitFile(file){
				var isJPG = file.type === 'image/jpeg' 
						 || file.type === 'image/png' 
						 || file.type === 'image/jpg' 
						 || file.type === 'application/pdf';
				var isLt2M = file.size / 1024 / 1024 < 200;
				if (!isJPG) {
					Message.error('请上传系统支持的文件格式');
					return false;
				}
				if (!isLt2M) {
					Message.error('上传文件大小不能超过 200MB!');
					return false;
				}
			},
			removeFile(){
				this.fileList = []
			},
			removeFile1(){
				this.fileList1 = []
			},
			// 下载表格
			download(){
				this.$emit("downExcel")
			},
			pushData(){
				var that = this;
				that.formData.uid = that.uid;
				dyjy.transferIntroduce(that.formData).then(res => {
					if(res.code == 200){
						that.closeUpload();
					}else{
						Message.error(res.msg)
					}
				})
			},
			// 上传成功
			success(res, file) {
				var that = this;
				if(res.code == 200){
					that.formData.introduce = "";
					that.formData.introduce = res.data.src
				}else{
					Message({
						type:"error",
						message:"上传失败，请检查文件或网络连接"
					})
				}
			},
			// 上传成功
			success1(res, file) {
				var that = this;
				if(res.code == 200){
					that.formData.receipt = [];
					that.formData.receipt = res.data.src
				}else{
					Message({
						type:"error",
						message:"上传失败，请检查文件或网络连接"
					})
				}
			}
		}
	}
</script>

<style lang="scss">
	.formData1{
		width: 100%;
		display: flex;
		justify-content: center;
		.form_item{
			display: flex;
			align-items: center;
		}
	}
</style>
